<template>
  <b-card title="گزارش برداشت ها از بانک آینده">
    <b-modal
      id="transaction-verification-tab1"
      title="تایید تراکنش"
      @ok="VerifyTransaction"
      ok-title="بلی"
      cancel-title="خیر"
    >
      آیا از تایید تراکنش اطمینان دارید؟
    </b-modal>
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="12" md="3" sm="6">
            <b-form-group label="تاریخ:">
              <date-picker v-model="date" clearable></date-picker>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="12" sm="12">
            <b-button class="mr-2" variant="success" @click="getdata()"
              >جستجو</b-button
            >
            <b-button variant="danger" @click="exportExcel()"
              >دریافت فایل اکسل</b-button
            >
            <b-button variant="warning" @click="clearCache()">
              بروزرسانی درگاه ها
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div class="row pt-5">
      <div class="col-md-12">
        <b-form-group
          label="تسویه های نوع ۲ و واریز به حساب آینده و کارمزد های نوع ۳:"
        >
          <b-table
            responsive
            :items="
              records.filter((t) => {
                return t.iban === 'IR460620000000203387368000';
              })
            "
            :fields="bardashtReezFields"
          >
          </b-table>
        </b-form-group>
        <b-form-group label="تسویه های نوع ۳ و واریز به حساب مشتری:">
          <b-table
            responsive
            :items="
              records.filter((t) => {
                return t.iban !== 'IR460620000000203387368000';
              })
            "
            :fields="bardashtReezFields"
          >
          </b-table>
        </b-form-group>
        <b-form-group label="درگاه های واسط:">
          <b-table responsive :items="recordsForVerify" :fields="VasetFields">
            <template v-slot:cell(details)="row">
              <div class="collect-link">
                <b-button
                  @click="showVerifyModal(row.item)"
                  v-if="row.item.is_verify == false"
                  class="btn btn-primary btn-sm p-0 pl-1 pr-1 mr-1"
                  >تایید تراکنش</b-button
                >
              </div>
            </template>
          </b-table>
        </b-form-group>
      </div>
    </div>
  </b-card>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import persianDate from "../../helpers/persianDate";
import NumberSeprator from "@/components/numberSeprator";
import { saveExcel } from "@progress/kendo-vue-excel-export";
import _ from "lodash";
import moment from "jalali-moment";
export default {
  name: "ayandereport",
  components: {
    NumberSeprator,
  },
  data() {
    return {
      recordsForVerify: [],
      id_for_verify: null,
      date: moment().format("jYYYY/jMM/jDD"),
      bardashtShode: 0,
      website_name: null,
      tracking_number: null,
      karmozdha: 0,
      karmozdha_psp: 0,
      records: [],
      VasetFields: [
        {
          key: "gateway.website_name",
          label: "وبسایت",
        },
        {
          key: "gateway.website",
          label: "آدرس وبسایت",
        },
        {
          key: "cost",
          label: "مبلغ",
          formatter: (value, key, item) => {
            return Number(-1 * value).toLocaleString();
          },
        },
        {
          key: "shepa_karmozd",
          label: "کارمزد شپا",
          formatter: (value, key, item) => {
            return Number(-1 * value).toLocaleString();
          },
        },
        {
          key: "shaparak_karmozd",
          label: "کارمزد نظام بانکی",
          formatter: (value, key, item) => {
            return Number(-1 * value).toLocaleString();
          },
        },
        {
          key: "details",
          label: "تایید",
        },
      ],
      karmozdReezFields: [
        {
          key: "gateway.website_name",
          label: "وبسایت",
        },
        {
          key: "bed",
          label: "مبلغ",
          formatter: (value, key, item) => {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "bank",
          label: "بانک",
        },
      ],
      bardashtReezFields: [
        {
          key: "gateway.website_name",
          label: "وبسایت",
        },
        {
          key: "gateway.website",
          label: "آدرس وبسایت",
        },
        {
          key: "trackingNumber",
          label: "کد رهگیری پرداخت",
        },
        {
          key: "amount",
          label: "مبلغ",
          formatter: (value, key, item) => {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "acceptorWageAmount",
          label: "کارمزد نظام بانکی",
          formatter: (value, key, item) => {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "amountWithWage",
          label: "باقیمانده",
          formatter: (value, key, item) => {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "iban",
          label: "شماره شبا",
          formatter: (value, key, item) => {
            return value;
          },
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "گزارش برداشت ها از بانک آینده" },
    ]);
    this.getdata();
  },
  methods: {
    clearCache() {
      httpHelper.getData("~reports/api/gateway/resetCache").then((res) => {
        this.getdata();
      });
    },
    exportExcel() {
      saveExcel({
        data: this.records.filter((t) => {
          return t.iban === "IR460620000000203387368000";
        }),
        fileName: "settlements",
        columns: [
          {
            title: "وبسایت",
            field: "gateway.website_name",
          },
          {
            title: "آدرس وبسایت",
            field: "gateway.website",
          },
          {
            title: "کد رهگیری پرداخت",
            field: "trackingNumber",
          },
          {
            title: "مبلغ",
            field: "amount",
          },
          {
            title: "کارمزد نظام بانکی",
            field: "acceptorWageAmount",
          },
          {
            title: "باقیمانده",
            field: "amountWithWage",
          },
        ],
      });
    },
    showVerifyModal(e) {
      this.id_for_verify = e.id;
      this.$bvModal.show("transaction-verification-tab1");
    },
    VerifyTransaction(e) {
      e.preventDefault();
      httpHelper
        .getData(
          "~transaction/transaction/admin/verify_trans/" + this.id_for_verify
        )
        .then((res) => {
          this.records = [];
          this.$bvModal.hide("transaction-verification-tab1");
          this.getdata();
        });
    },
    CalcResult(data) {
      this.bardashtShode = _.sumBy(data, function (o) {
        return -1 * o.cost;
      });
      this.karmozdha = _.sumBy(data, function (o) {
        return o.shepa_karmozd < 0 ? -1 * o.shepa_karmozd : 0;
      });
      this.karmozdha_psp = _.sumBy(data, function (o) {
        return o.shaparak_karmozd < 0 ? -1 * o.shaparak_karmozd : 0;
      });
    },
    getdata() {
      var url = "~reports/api/accounters/sattlement?date=" + this.date;
      if (this.website_name) {
        url += "&website_name=" + this.website_name;
      }
      if (this.tracking_number) {
        url += "&tracking_number=" + this.tracking_number;
      }
      if (this.amount) {
        url += "&website_name=" + this.amount;
      }
      httpHelper.getData(url).then((res) => {
        this.records = res;
      });
      this.getdataForIranicard();
    },
    getdataForIranicard() {
      var url = "~transaction/operation/Payouts?date=" + this.date;
      httpHelper.getData(url).then((res) => {
        this.recordsForVerify = res.result.filter((t) => {
          return (
            t.sale_refrence_id == null && t.acceptor_code !== "000000002941740"
          );
        });
      });
    },
  },
};
</script>